/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          if (evt.target.closest('.drawer-body') || evt.detail === 0) {
            evt.preventDefault();
          }
          if (evt.detail === 0) return;
          this.toggleDropdown();
        });
      } else if (type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
          this.dropdownShow(this.dropdown);
        });
        this.toggleCTA.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdown);
        });
      } else if (type === 'mouseleave') {
        this.dropdown.addEventListener(type, (evt) => {
          this.dropdownHide(this.dropdown);
        });
      } else if (type == 'focusout') {
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    this.toggleCTA.addEventListener('keydown', (evt) => {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      evt.preventDefault();
      evt.stopPropagation();
      this.toggleDropdown();
    });

    this.bindEvents();
  }

  bindEvents() {
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement {
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents() {
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick() {
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if (closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));

    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
  showOverlay() {
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay() {
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });

    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';
    this.isPlaying = false;

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if (this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    // Only autoplay on init if not popup placement (popup should open on click)
    if(this.dataset.autoplay == 'true' && !this.closest('swiper-slide') && this.placementType !== 'popup') this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event) {
    if (this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event) {
    if (event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    const shouldAutoplay = this.dataset.autoplay == 'true';
    
    // If autoplay is false, directly control play/pause
    if(!shouldAutoplay) {
      if (this.videoStatus === 'empty') {
        // Use requestAnimationFrame to prevent UI freezing
        requestAnimationFrame(() => {
          // Video not loaded yet, build it but keep poster visible
          const videoElement = this._buildVideo();
          videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
          this.videoSection.appendChild(videoElement);
          this.videoStatus = 'loaded';
          
          // Keep poster visible (don't add playing--video class yet)
          // Video section is hidden by default CSS
          
          // Set volume when video is built
          this._setVolume(videoElement);
          
          // Handle popup placement
          if (this.placementType === 'popup') {
            // For popup, open modal and play video
            setTimeout(() => {
              openModal(this.videoModal, this.triggerVideo);
              this.videoSection.setAttribute('aria-hidden', 'false');
              const shouldAutoplay = this.dataset.autoplay == 'true';
              if (shouldAutoplay) {
                this._playVideo(videoElement);
              } else {
                this._updatePlayButtonIcon(false);
              }
            }, 500);
          } else {
            // Play video based on type
            if (this.type === 'local') {
              // For local videos, wait for canplay event
              videoElement.addEventListener('canplay', () => {
                // Now show video section and hide poster
                this.container.classList.add('playing--video');
                this.videoSection.setAttribute('aria-hidden', 'false');
                this._playVideo(videoElement);
              }, { once: true });
              // Also try to play immediately if already ready
              if (videoElement.readyState >= 3) {
                this.container.classList.add('playing--video');
                this.videoSection.setAttribute('aria-hidden', 'false');
                this._playVideo(videoElement);
              }
            } else {
              // For YouTube/Vimeo iframes, wait for iframe to fully load before showing
              let hasShown = false;
              const showAndPlay = () => {
                if (hasShown) return;
                hasShown = true;
                
                // Small delay to ensure iframe API is ready
                setTimeout(() => {
                  // Now show video section and hide poster (smooth transition)
                  this.container.classList.add('playing--video');
                  this.videoSection.setAttribute('aria-hidden', 'false');
                  // Then play the video
                  this._playVideo(videoElement);
                }, 300);
              };
              
              // Wait for iframe load event (primary method)
              videoElement.addEventListener('load', showAndPlay, { once: true });
              
              // Fallback: if iframe loads very quickly, check after a short delay
              setTimeout(() => {
                if (!hasShown && videoElement.contentWindow) {
                  showAndPlay();
                }
              }, 500);
              
              // Safety timeout: show after max 2 seconds even if load event doesn't fire
              setTimeout(() => {
                if (!hasShown) {
                  showAndPlay();
                }
              }, 2000);
            }
          }
        });
      } else {
        // Video is loaded, toggle play/pause
        let videoElement = this.videoSection.querySelector('video') || this.videoSection.querySelector('iframe');
        
        // If video element not found (e.g., modal was closed and cleared), rebuild it
        if (!videoElement) {
          videoElement = this._buildVideo();
          videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
          this.videoSection.appendChild(videoElement);
          this.videoStatus = 'loaded';
          // Set volume when video is rebuilt
          this._setVolume(videoElement);
        }
        
        if (videoElement) {
          if (this.isPlaying) {
            // Pause the video
            this._pauseVideo(videoElement);
          } else {
            // Play the video
            if (this.placementType === 'popup') {
              // For popup, open modal if not already open
              if (this.videoModal && !this.videoModal.classList.contains('open')) {
                openModal(this.videoModal, this.triggerVideo);
                // Small delay to ensure modal is open before playing
                setTimeout(() => {
                  this.videoSection.setAttribute('aria-hidden', 'false');
                  this._playVideo(videoElement);
                }, 300);
              } else {
                this.videoSection.setAttribute('aria-hidden', 'false');
                this._playVideo(videoElement);
              }
            } else {
              if (!this.container.classList.contains('playing--video')) {
                this.container.classList.add('playing--video');
                this.videoSection.setAttribute('aria-hidden', 'false');
              }
              this._playVideo(videoElement);
            }
          }
        }
      }
    } else {
      // Autoplay is on
      if (this.placementType === 'popup') {
        // For popup with autoplay, only open modal on click (don't autoplay on page load)
        if (this.videoStatus === 'empty') {
          // Build video and open modal
          requestAnimationFrame(() => {
            const videoElement = this._buildVideo();
            videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
            this.videoSection.appendChild(videoElement);
            this.videoStatus = 'loaded';
            // Set volume when video is built
            this._setVolume(videoElement);
            
            setTimeout(() => {
              openModal(this.videoModal, this.triggerVideo);
              this.videoSection.setAttribute('aria-hidden', 'false');
              // Autoplay the video in modal
              this._playVideo(videoElement);
            }, 500);
          });
          } else {
            // Video already loaded
            if (this.videoModal && this.videoModal.classList.contains('open')) {
              // Modal is open, close it
              this.hideContent();
            } else {
              // Modal is closed, open it and play video
              // Check if video element exists in the modal's video container
              let videoElement = this.videoSection.querySelector('video') || this.videoSection.querySelector('iframe');
              
              // If video not found, rebuild it
              if (!videoElement) {
                videoElement = this._buildVideo();
                videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
                this.videoSection.appendChild(videoElement);
                this.videoStatus = 'loaded';
                // Set volume when video is rebuilt
                this._setVolume(videoElement);
              }
              
              // Open modal and play
              openModal(this.videoModal, this.triggerVideo);
              this.videoSection.setAttribute('aria-hidden', 'false');
              
              // Small delay to ensure modal is open before playing
              setTimeout(() => {
                this._playVideo(videoElement);
              }, 300);
            }
          }
      } else {
        // Original behavior for autoplay videos (inline)
        if (isOpen) {
          this.hideContent();
        } else {
          this.showContent();
        }
      }
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        const shouldAutoplay = this.dataset.autoplay == 'true';
        // Set volume for all videos (autoplay or not)
        this._setVolume(videoElement);
        if (shouldAutoplay) {
          this._playVideo(videoElement);
        } else {
          // For non-autoplay, show video but don't play yet
          this._updatePlayButtonIcon(false);
        }
        if (this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      const shouldAutoplay = this.dataset.autoplay == 'true';
      // Set volume for all videos (autoplay or not)
      this._setVolume(videoElement);
      if (shouldAutoplay) {
        this._playVideo(videoElement);
      }
      if (!shouldAutoplay) {
        this._updatePlayButtonIcon(false);
      }
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  /**
   * Set volume to 20% for videos (if not muted)
   */
  _setVolume(video) {
    if (!video) return;

    const isMuted = this.dataset.muted === 'true';
    if (isMuted) return;

    if (this.type === 'local') {
      video.volume = 0.2;
    } else if (this.type === 'youtube' || this.type === 'dynamic') {
      const setVolumeCommand = () => {
        try {
          if (video.contentWindow) {
            if (video.src && video.src.includes('vimeo.com')) {
              video.contentWindow.postMessage('{"method":"setVolume","value":0.2}', '*');
            } else {
              video.contentWindow.postMessage('{"event":"command","func":"setVolume","args":[20]}', '*');
            }
          }
        } catch (e) {
          // If error, try again after a short delay
          setTimeout(setVolumeCommand, 100);
        }
      };
      
      // Try to set volume immediately if iframe is ready
      if (video.contentWindow) {
        setVolumeCommand();
        // Retry after a delay to ensure it's set
        setTimeout(setVolumeCommand, 400);
      } else {
        // Wait for iframe to be ready
        setTimeout(setVolumeCommand, 200);
        setTimeout(setVolumeCommand, 600);
      }
    }
  }

  _playVideo(video){
    this.isPlaying = true;
    if(this.type == 'local'){
      video.play().then(() => {
        this._updatePlayButtonIcon(true);
      }).catch(() => {
        this.isPlaying = false;
        this._updatePlayButtonIcon(false);
      });
    }else if(this.type == 'youtube' || this.type == 'dynamic'){
      // Update icon immediately
      this._updatePlayButtonIcon(true);
      
      this._setVolume(video);
      
      // Send play command to iframe
      const sendPlayCommand = () => {
        try {
          // Check if it's Vimeo
          if (video.src && video.src.includes('vimeo.com')) {
            video.contentWindow.postMessage('{"method":"play"}', '*');
          } else {
            // YouTube
            video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        } catch (e) {
          // If error, try again after a short delay
          setTimeout(sendPlayCommand, 100);
        }
      };
      
      // Try to send command immediately
      if (video.contentWindow) {
        sendPlayCommand();
        // Retry once after a delay to ensure it plays (YouTube API sometimes needs a retry)
        setTimeout(sendPlayCommand, 400);
      } else {
        // Wait for iframe to be ready
        setTimeout(sendPlayCommand, 200);
      }
    }
  }

  /**
   * Update play/pause button icon
   */
  _updatePlayButtonIcon(isPlaying) {
    if (!this.triggerVideo) return;
    // Don't update icon for popup placement - video plays in modal, not from this button
    if (this.placementType === 'popup') return;
    
    const playIcon = this.triggerVideo.querySelector('.play-icon');
    const pauseIcon = this.triggerVideo.querySelector('.pause-icon');
    
    if (playIcon && pauseIcon) {
      if (isPlaying) {
        playIcon.classList.add('d-none');
        pauseIcon.classList.remove('d-none');
      } else {
        playIcon.classList.remove('d-none');
        pauseIcon.classList.add('d-none');
      }
    }
  }

  _pauseVideo(video) {
    this.isPlaying = false;
    if (this.type === 'local') {
      video.pause();
      this._updatePlayButtonIcon(false);
    } else if (this.type === 'youtube' || this.type === 'dynamic') {
      if (video.contentWindow) {
        // Check if it's Vimeo
        if (video.src && video.src.includes('vimeo.com')) {
          video.contentWindow.postMessage('{"method":"pause"}', '*');
        } else {
          // YouTube
          video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        this._updatePlayButtonIcon(false);
      }
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo() {
    let video;
    let videoURL = this.videoURL;

    if (this.type == 'local') {
      video = document.createElement('video');
      video.src = videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      const isMuted = this.dataset.muted === 'true';
      video.muted = isMuted;
      if (!isMuted) {
        video.volume = 0.2;
      }
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      // Set loop explicitly - only loop if set to true, otherwise explicitly false
      const shouldLoop = this.dataset.loop === 'true';
      video.loop = shouldLoop;
      video.playsInline = true;
    }else if(this.type == 'youtube' || this.type == 'dynamic'){
      // Check autoplay setting
      const shouldAutoplay = this.dataset.autoplay == 'true';
      
      // Extract video ID from various YouTube URL formats
      let videoID = '';
      if(videoURL.includes('youtube.com/watch?v=')){
        videoID = videoURL.split('v=')[1]?.split('&')[0];
      }else if(videoURL.includes('youtu.be/')){
        videoID = videoURL.split('youtu.be/')[1]?.split('?')[0];
      }else if(videoURL.includes('youtube.com/embed/')){
        videoID = videoURL.split('embed/')[1]?.split('?')[0];
      }else if(videoURL.includes('vimeo.com/')){
        // Handle Vimeo URLs
        const vimeoID = videoURL.match(/vimeo\.com\/(\d+)/)?.[1];
        if(vimeoID){
          video = document.createElement( "iframe" );
          video.setAttribute( "allowfullscreen", "" );
          video.setAttribute( "frameborder", "0" );
          video.setAttribute( "allow", "autoplay");
          const isMuted = this.dataset.muted === 'true';
          const hasControls = this.dataset.controls === 'true';
          const shouldLoop = this.dataset.loop === 'true';
          // According to Vimeo docs, only include loop parameter when enabled, remove it entirely when disabled
          const loopParam = shouldLoop ? '&loop=1' : '&loop=0';
          video.setAttribute( "src", `https://player.vimeo.com/video/${vimeoID}?autoplay=${shouldAutoplay ? 1 : 0}&muted=${isMuted ? 1 : 0}${loopParam}&controls=${hasControls ? 1 : 0}` );
          return video;
        }
      }
      
      if(videoID){
        video = document.createElement( "iframe" );
        video.setAttribute( "allowfullscreen", "" );
        video.setAttribute( "frameborder", "0" );
        video.setAttribute( "allow", "autoplay");
        const isMuted = this.dataset.muted === 'true';
        const hasControls = this.dataset.controls === 'true';
        const shouldLoop = this.dataset.loop === 'true';
        // For YouTube, loop requires playlist parameter to work. If loop is disabled, don't include loop parameter
        const loopParam = shouldLoop ? `&loop=1&playlist=${videoID}` : '';
        // For YouTube, muted parameter must be set correctly. When muted is true, set mute=1, otherwise set mute=0
        const muteParam = `&mute=${isMuted ? 1 : 0}`;
        video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=${shouldAutoplay ? 1 : 0}${muteParam}&controls=${hasControls ? 1 : 0}${loopParam}&enablejsapi=1&origin=${window.origin}` );
      }
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle) {
    this.scrollObserver = new IntersectionObserver((entries) => {
      if (videoEle == undefined || videoEle.contentWindow == null) {
        this.scrollObserver.disconnect();
        return;
      }

      if (!entries[0].isIntersecting) {
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos() {
    const posterVideo = this.querySelector('[data-postervideo]');
    if (!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this) {
    const elementIntersection = (entries) => {
      if (entries[0].isIntersecting && entries[0].intersectionRatio > 0) {
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
customElements.define("custom-video", CustomVideo);

/**
  * Open Modal javscript trigger
  *
  * */
function openModal(modal, opener) {
  if (modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      // Close modal if clicking outside the modal-content (on backdrop or modal-dialog)
      const modalContent = this.querySelector('.modal-content');
      if (evt.target === this || (modalContent && !modalContent.contains(evt.target))) {
        this.hide();
      }
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') {
      this.querySelector('.video-container').innerHTML = '';
      // Reset videoStatus for all CustomVideo instances with popup placement
      document.querySelectorAll('custom-video[data-placement="popup"]').forEach(customVideo => {
        if (customVideo.videoStatus) {
          customVideo.videoStatus = 'empty';
          customVideo.isPlaying = false;
        }
      });
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options) {
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame = 0;
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'), this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;

    this.openedBy = null;
    this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
    this.closeButtons = this.querySelectorAll('[data-closedrawer]');
    this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    if (!this.classList.contains('open')) {
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
    }
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents() {
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (btn.dataset.for == 'collection-sorting') {
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }, 500);
        } else {
          (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
        }

      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if (evt.keyCode && evt.keyCode !== 27) return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt) {
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');
    this.openedBy?.setAttribute('aria-expanded', true);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
  }

  closeDrawer() {
    this.isOpen = false;
    this.classList.remove('open');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
    this.openedBy?.setAttribute('aria-expanded', false);
    setTimeout(() => {
      this.classList.remove('collection-sorting');
    }, 500);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    this.openedBy = null;
  }

  resetOtherDrawers() {
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      // drawer.closeDrawer();
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

/**
 * ReadMore Component
 * Handles text truncation and expansion functionality
 */
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.maxLines = parseInt(this.dataset.maxLine) || 3;
    this.isExpanded = false;
    this.originalText = '';
    this.readMoreLink = null;
    this.textContainer = null;
    this.fadeGradient = null;
    this.maxHeight = 0;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.readMoreLink) {
      this.readMoreLink.removeEventListener('click', this.toggle.bind(this));
    }
  }

  init() {
    this.originalText = this.innerHTML.trim();
    this.textContainer = document.createElement('div');
    this.textContainer.className = 'read-more-text';
    this.textContainer.innerHTML = this.originalText;

    this.innerHTML = '';
    this.appendChild(this.textContainer);

    // Check if text needs truncation after DOM render
    setTimeout(() => this.checkTruncation(), 100);
  }

  checkTruncation() {
    const computedStyle = window.getComputedStyle(this.textContainer);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    this.maxHeight = lineHeight * this.maxLines;

    // Create temporary element to measure full text height
    const testElement = document.createElement('div');
    testElement.style.cssText = `
      position: absolute;
      visibility: hidden;
      width: ${this.textContainer.offsetWidth}px;
      font-size: ${computedStyle.fontSize};
      line-height: ${computedStyle.lineHeight};
      font-family: ${computedStyle.fontFamily};
      word-wrap: break-word;
      overflow-wrap: break-word;
    `;
    testElement.innerHTML = this.originalText;
    document.body.appendChild(testElement);

    const needsTruncation = testElement.offsetHeight > this.maxHeight;
    document.body.removeChild(testElement);

    if (needsTruncation) {
      this.setupTruncation();
    }
  }

  setupTruncation() {
    // Apply initial truncation height
    this.textContainer.style.maxHeight = `${this.maxHeight}px`;

    // Add fade gradient
    this.fadeGradient = document.createElement('div');
    this.fadeGradient.className = 'read-more-fade';
    this.textContainer.appendChild(this.fadeGradient);

    // Create read more link
    this.readMoreLink = document.createElement('a');
    this.readMoreLink.href = '#';
    this.readMoreLink.className = 'read-more-link fade-in mt-1';
    this.readMoreLink.textContent = 'Read More';
    this.appendChild(this.readMoreLink);

    // Animate in the link
    setTimeout(() => {
      this.readMoreLink.classList.add('show');
    }, 100);

    // Bind events
    this.readMoreLink.addEventListener('click', this.toggle.bind(this));
  }

  toggle(event) {
    event.preventDefault();
    this.isExpanded ? this.collapse() : this.expand();
  }



  expand() {
    this.isExpanded = true;

    // Hide fade gradient
    if (this.fadeGradient) {
      this.fadeGradient.style.opacity = '0';
    }

    // Add animation class and expand
    this.readMoreLink.classList.add('text-changing');
    const fullHeight = this.textContainer.scrollHeight;
    this.textContainer.style.maxHeight = `${fullHeight}px`;

    setTimeout(() => {
      this.textContainer.style.maxHeight = `${fullHeight}px`;
      this.readMoreLink.textContent = 'Read Less';
      this.readMoreLink.classList.remove('text-changing');
    }, 200);
  }

  collapse() {
    this.isExpanded = false;

    // Show fade gradient
    if (this.fadeGradient) {
      this.fadeGradient.style.opacity = '0.1';
    }

    // Add animation class and collapse
    this.readMoreLink.classList.add('text-changing');
    this.textContainer.style.maxHeight = `${this.textContainer.scrollHeight}px`;

    setTimeout(() => {
      this.textContainer.style.maxHeight = `${this.maxHeight}px`;
      this.readMoreLink.textContent = 'Read More';
      this.readMoreLink.classList.remove('text-changing');
    }, 50);
  }
}

customElements.define('read-more', ReadMore);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index + 2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index + 1}"]`);

    // Pause previous slide video if available
    if (prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')) {
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if (videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if (prevSlide && activeSlide.querySelector('.custom-video-container')) {
      let customElement = activeSlide.querySelector('custom-video');
      if (customElement.videoStatus == 'empty') {
        customElement.toggleView();
      } else {
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if (videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});


(function updateTopinRoot() {
  let headerEle = document.querySelector('.section-header');

  if (headerEle != undefined) {
    let headerHeight = headerEle.clientHeight;
    document.querySelector(':root').style.setProperty('--bs-navdrawer', `${headerHeight}px`);
    document.querySelector(':root').style.setProperty('--bs-mobile-navdrawer', `${headerHeight}px`);
  }
  // Calculate total height of all sticky announcement bars
  const stickyTopbars = document.querySelectorAll('[data-top-bar][data-sticky="true"]');
  let totalTopbarHeight = 0;
  stickyTopbars.forEach(topbar => {
    totalTopbarHeight += topbar.clientHeight;
  });
  document.documentElement.style.setProperty('--bs-topbar-height', `${totalTopbarHeight}px`);

})()


// Select all elements with class 'media-with-text'
const sections = document.querySelectorAll('.media-with-text.with-animate');

// Function to check and add 'animated' class to sections above the viewport
function checkInitialSections() {
  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    // Check if the section is above the viewport on page load
    if (rect.bottom < 0) {
      section.classList.add('animated');
    }
  });
}

// Create an Intersection Observer
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Add 'visible' class when the section is in viewport
      entry.target.classList.add('animated');
      // Optionally, stop observing after adding the class
      // observer.unobserve(entry.target);
    }
  });
}, {
  root: null, // Use the viewport as the root
  rootMargin: '0px', // Margin around the root
  threshold: 0.2 // Trigger when 20% of the element is visible
});

// Observe each section
sections.forEach(section => {
  observer.observe(section);
});

// Run the check on page load
document.addEventListener('DOMContentLoaded', checkInitialSections);

document.addEventListener('click', (evt) => {
  const skipLink = evt.target.closest('[data-skip-to-chat]');
  if (!skipLink) return;
  const chat = window.GorgiasChat || window.gorgiasChat;
  if (!chat || typeof chat.open !== 'function') return;
  evt.preventDefault();
  chat.open();
  setTimeout(() => {
    const frame = document.querySelector('iframe[id*="gorgias"], iframe[title*="chat" i]');
    frame?.focus();
  }, 300);
});